document.addEventListener("DOMContentLoaded", () => {

    const header = document.querySelector(".ph-header");

    if (!header) return;

    let lastScroll = 0;

    window.addEventListener("scroll", () => {

        const currentScroll = window.scrollY;

        // Transparent header (Homepage only)
        if (header.classList.contains("ph-transparent-home")) {

            if (currentScroll <= 5) {

                header.classList.remove("ph-scrolled");
                header.classList.remove("ph-hide");

                lastScroll = currentScroll;
                return;

            } else {

                header.classList.add("ph-scrolled");

            }

        }

        // Hide on scroll down
        if (currentScroll > lastScroll && currentScroll > 120) {

            header.classList.add("ph-hide");

        }

        // Show on scroll up
        else {

            header.classList.remove("ph-hide");

        }

        lastScroll = currentScroll;

    });

});

// document.addEventListener('DOMContentLoaded', function () {

//     const search = document.querySelector('.ph-search');

//     if (!search) return;

//     const searchButton = search.querySelector('button');
//     const searchInput = search.querySelector('input');

//     if (!searchButton || !searchInput) return;

//     searchButton.addEventListener('click', function (event) {

//         if (
//             window.innerWidth <= 749 &&
//             !search.classList.contains('mobile-search-open')
//         ) {

//             event.preventDefault();

//             search.classList.add('mobile-search-open');

//             setTimeout(function () {
//                 searchInput.focus();
//             }, 300);

//         }

//     });

// });

document.addEventListener('DOMContentLoaded', function () {

    const search = document.querySelector('.ph-search');
    const logo = document.querySelector('.ph-center');

    if (!search) return;

    const searchButton = search.querySelector('button');
    const searchInput = search.querySelector('input');

    if (!searchButton || !searchInput) return;

    searchButton.addEventListener('click', function (event) {

        if (
            window.innerWidth <= 749 &&
            !search.classList.contains('mobile-search-open')
        ) {

            event.preventDefault();

            search.classList.add('mobile-search-open');

            if (logo) {
                logo.classList.add('mobile-logo-hidden');
            }

            setTimeout(function () {
                searchInput.focus();
            }, 300);

        }

    });

});

document.addEventListener('DOMContentLoaded', function () {

  function updateCartCount() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed');
      }

      return response.json();
    })
    .then(function (cart) {

      document.querySelectorAll('.ph-cart-count').forEach(function (element) {
        element.textContent = cart.item_count;
      });

    })
    .catch(function (error) {
      console.error('Cart count error:', error);
    });
  }


  // Initial cart count
  updateCartCount();


  // Shopify cart events
  [
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'cart:build',
    'cart:open'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(updateCartCount, 100);
    });
  });


  // Monitor AJAX/fetch cart requests
  var originalFetch = window.fetch;

  window.fetch = function () {

    var requestUrl = '';

    if (typeof arguments[0] === 'string') {
      requestUrl = arguments[0];
    } else if (arguments[0] && arguments[0].url) {
      requestUrl = arguments[0].url;
    }

    return originalFetch.apply(this, arguments).then(function (response) {

      if (
        requestUrl.includes('/cart/add') ||
        requestUrl.includes('/cart/change') ||
        requestUrl.includes('/cart/update') ||
        requestUrl.includes('/cart/clear')
      ) {
        setTimeout(updateCartCount, 300);
      }

      return response;
    });
  };


  // Monitor XMLHttpRequest cart requests
  var originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {

    this.addEventListener('load', function () {

      if (
        typeof url === 'string' &&
        (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        )
      ) {
        setTimeout(updateCartCount, 300);
      }

    });

    return originalOpen.apply(this, arguments);
  };


});